"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaQueryController = void 0;
/**
 * 미디어 쿼리의 일치 여부가 바뀌면 호스트를 다시 렌더한다.
 * 같은 조건을 CSS로 표현할 수 있으면 미디어 쿼리를 쓰고, 이 컨트롤러는
 * 화면 크기에 따라 표면 컴포넌트 자체가 갈리는 것처럼 render에서 골라야 하는 분기에만 쓴다.
 * 조건은 constants의 MEDIA_QUERY를 넘겨 브레이크포인트를 CSS와 한 곳에서 공유한다.
 * 다시 렌더하는 것만으로 부족해 상태를 바꿔야 하면 onChange를 넘긴다. 연결될 때 한 번, 이후 일치 여부가 바뀔 때마다 호출된다.
 */
class MediaQueryController {
    constructor(host, query, onChange) {
        this.host = host;
        this.onChange = onChange;
        this.handleQueryChange = () => {
            this.onChange?.(this.query.matches);
            this.host.requestUpdate();
        };
        this.query = window.matchMedia(query);
        host.addController(this);
    }
    get matches() {
        return this.query.matches;
    }
    hostConnected() {
        this.query.addEventListener('change', this.handleQueryChange);
        this.onChange?.(this.query.matches);
    }
    hostDisconnected() {
        this.query.removeEventListener('change', this.handleQueryChange);
    }
}
exports.MediaQueryController = MediaQueryController;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWVkaWEtcXVlcnktY29udHJvbGxlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm1lZGlhLXF1ZXJ5LWNvbnRyb2xsZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRUE7Ozs7OztHQU1HO0FBQ0gsTUFBYSxvQkFBb0I7SUFHL0IsWUFDVSxJQUE0QixFQUNwQyxLQUFhLEVBQ0wsUUFBcUM7UUFGckMsU0FBSSxHQUFKLElBQUksQ0FBd0I7UUFFNUIsYUFBUSxHQUFSLFFBQVEsQ0FBNkI7UUFtQnZDLHNCQUFpQixHQUFHLEdBQUcsRUFBRTtZQUMvQixJQUFJLENBQUMsUUFBUSxFQUFFLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxPQUFPLENBQUMsQ0FBQTtZQUNuQyxJQUFJLENBQUMsSUFBSSxDQUFDLGFBQWEsRUFBRSxDQUFBO1FBQzNCLENBQUMsQ0FBQTtRQXBCQyxJQUFJLENBQUMsS0FBSyxHQUFHLE1BQU0sQ0FBQyxVQUFVLENBQUMsS0FBSyxDQUFDLENBQUE7UUFDckMsSUFBSSxDQUFDLGFBQWEsQ0FBQyxJQUFJLENBQUMsQ0FBQTtJQUMxQixDQUFDO0lBRUQsSUFBSSxPQUFPO1FBQ1QsT0FBTyxJQUFJLENBQUMsS0FBSyxDQUFDLE9BQU8sQ0FBQTtJQUMzQixDQUFDO0lBRUQsYUFBYTtRQUNYLElBQUksQ0FBQyxLQUFLLENBQUMsZ0JBQWdCLENBQUMsUUFBUSxFQUFFLElBQUksQ0FBQyxpQkFBaUIsQ0FBQyxDQUFBO1FBQzdELElBQUksQ0FBQyxRQUFRLEVBQUUsQ0FBQyxJQUFJLENBQUMsS0FBSyxDQUFDLE9BQU8sQ0FBQyxDQUFBO0lBQ3JDLENBQUM7SUFFRCxnQkFBZ0I7UUFDZCxJQUFJLENBQUMsS0FBSyxDQUFDLG1CQUFtQixDQUFDLFFBQVEsRUFBRSxJQUFJLENBQUMsaUJBQWlCLENBQUMsQ0FBQTtJQUNsRSxDQUFDO0NBTUY7QUE3QkQsb0RBNkJDIn0=